import {gql} from '@apollo/client';

export default gql`
    fragment Like on Like {
        likedAt
        reaction
        likedBy {
            profileImage {
                url
            }
            name {
                firstName
                fullName
            }
        }
    }
`;
